import React from "react";
/** Components Import */
import { Navbar, Container } from "react-bootstrap";

function Header({
  title = "",
  logo,
  children,
  onClick = () => {},
  onShow = () => {},
}) {
  return (
    <Navbar expand={false} className="header-navbar-wrap mb-3">
      <Container fluid>
        <Navbar.Brand
          style={{ display: "flex", alignItems: "center" }}
          onClick={onClick}
        >
          <img
            src={logo}
            width="30"
            height="30"
            className="d-inline-block align-top"
          />
          <div style={{ marginLeft: "8px" }}>{title}</div>
        </Navbar.Brand>
        <Navbar.Toggle onClick={onShow} />
        {children}
      </Container>
    </Navbar>
  );
}

export default Header;
